<template>
	<v-app>
		<v-container fluid style="margin-top: 40px; width:90%;font-family: 'Lucida Grande','Lucida Sans Unicode',Tahoma,sans-serif;">
			<v-toolbar flat color="white">
				<v-toolbar-title class="page-title">EXHIBITOR BOOTH SUBMISSION FORM</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-btn @click="showDialogHelp = true" rounded color="red">Help<v-icon>mdi-help-circle</v-icon></v-btn>
			</v-toolbar>

			<v-stepper non-linear v-model="e1">
				<v-stepper-header style="height:20vh">
					<v-stepper-step step="1" editable @click="openMenu(1)">Basic Information</v-stepper-step>
					<v-divider></v-divider>
					<v-stepper-step step="2" editable @click="openMenu(2)">Booth Design</v-stepper-step>
					<v-divider></v-divider>
					<v-stepper-step step="3" editable @click="openMenu(3)">Content Links</v-stepper-step>
					<v-divider></v-divider>
					<v-stepper-step step="4" editable @click="openMenu(4)">Documents/Videos</v-stepper-step>
					<v-divider></v-divider>
					<v-stepper-step step="5" editable @click="openMenu(5)">Booth Rep Accounts</v-stepper-step>
					<v-divider></v-divider>
					<v-stepper-step step="6" editable @click="openMenu(6)">Review/Publish</v-stepper-step>
				</v-stepper-header>

				<v-stepper-items>
					<v-stepper-content step="1">
						<v-card elevation="0">
							<v-card-title>
								<h2 class="font-title">BEFORE WE START!</h2>
							</v-card-title>
							<v-card-text>
								<span class="font-desc">
									Please be sure to review the information listed in your Exhibitor Handbook prior to filling in and submitting this form. For your reference, here are some sample booth designs we've created in the past. This will give you an idea of what a completed booth looks like and what we're aiming to do with the information we'll collect from you.
									<br />
								</span>
							</v-card-text>
						</v-card>

						<v-carousel height="auto">
							<v-carousel-item v-for="(item, i) in items" :key="i" eager>
								<v-img :src="item.src" contain eager></v-img>		
							</v-carousel-item>
						</v-carousel>

						<v-card>
							<v-form ref="formSetting" v-model="valid" @submit.prevent="saveStep1">
								<v-row>
									<v-col>
										<v-card-text>
											<h3>Full Name</h3>
											Please list the best contact details for the person managing your booth submission and any changes to your virtual booth
											<v-text-field class="input" v-model="contactName" outlined></v-text-field>
											<h3>Email Address<span style="color:red">*</span></h3>
											<v-text-field class="input" v-model="contactEmail" :rules="[(v) => !!v || 'This field cannot be blank.', (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid']" required outlined></v-text-field>
											<h3>Booth Name</h3>
											This is the name that will be displayed on your booth and also in the list of exhibitors. Usually, this is your company/department name.
											<v-text-field class="input" v-model="name" outlined></v-text-field>
											<h3>Booth Description</h3>
											<p>This is like an 'About Us' section that you can use to provide more information about your company/department. It can be as short or long as your prefer (but we recommend at least a few lines of text at a minimum)</p>
											<editor api-key="qd423wdft5go18d79gevmkpv8i92g9giyq6akdz5jc8ium67" :init="$root.initTinyMceEditor()" v-model="description" />
											<br/>
											<v-switch v-model="logoType" :label="'Logo type : ' + (logoType ? 'URL' : 'Upload')"></v-switch>
											<v-col cols="12" v-if="logoType">
												<v-text-field v-model="entity.logo" prepend-icon="mdi-image" label="Logo" placeholder="From Url" hint="A 200x200 pixels image size is highly recommended"></v-text-field>
											</v-col>
											<v-col cols="12" v-else>
												<v-file-input
													v-model="attachment"
													label="Logo"
													accept="image/png, image/jpeg"
													placeholder="Upload"
													prepend-icon="mdi-image"
													:show-size="1000"
													hint="A 200x200 pixels image size is highly recommended"
												>
													<template v-slot:selection="{ text }" :default="logo">
														<v-chip color="#0aabed" dark label small>{{ text }}</v-chip>
													</template>
												</v-file-input>
											</v-col>
											<v-switch v-model="entity.dataMap.noChatBooth" :label="'Turn Off Chat: ' + (entity.dataMap.noChatBooth ? 'True' : 'False')"></v-switch>
											<hr />

											<v-col cols="12">
												<h2>Add booth interests</h2>
											</v-col>
											<v-col cols="12" style="max-height:200px; overflow: auto;" v-if="showAddInterests == false">
												<v-chip class="primary" v-for="item in entity.interestNameList" :key="item" :value="item" style="margin-right: 5px">{{item}}</v-chip>
											</v-col>
											<v-col cols="12" v-if="showAddInterests == false">
												<v-btn @click="listInterest(); showAddInterests = true" class="primary px-8" rounded>Add Interests</v-btn>
											</v-col>

											<v-col v-if="showAddInterests == true">
												<div style="max-height:200px; overflow: auto;">
													<v-chip-group v-model="entity.interestList" active-class="primary" column multiple>
														<v-chip v-for="item in interestList" :key="item.id" :value="item.id">{{item.name}}</v-chip>
													</v-chip-group>
												</div>
											</v-col>
										</v-card-text>
									</v-col>
								</v-row>
								<div class="d-flex justify-end top">
									<v-btn :disabled="!valid" type="submit" color="#0aabed" depressed tile style="font-color:#FFFFFF !important;"
										>Save and Continue</v-btn>
								</div>
							</v-form>
						</v-card>
						
					</v-stepper-content>

					<v-stepper-content clas="top" step="2">
						<v-card elevation="0">
							<v-card-title><h2 class="font-title">SELECT YOUR BOOTH TEMPLATE</h2></v-card-title>
							<v-card-text>
								<span class="font-desc">
									The virtual booth design is the first thing attendees see when they open your booth. So we'll need to make it look nice and also representative of your brand. 
									<br />
									<br />We've got several different booth design templates to choose from. All templates have either 4, 5, or 6 placeholder areas or banners, where you need to provide high-quality images. Each banner is shown in gray with a big X inside and the dimensions are listed in pixels. The banners are numbered in order from left to right and top to bottom (ie banner 1 is always located on the top far left). Please provide a minimum of 300 dpi image resolution for each of your banner graphics.
								</span>
							</v-card-text>
						</v-card>
						<v-card elevation="0">
							<v-card-text>
								<div v-if="!showLibrary">
										<v-btn color="primary" @click="showLibrary=true">Change Your Booth Template</v-btn>
										<v-btn color="primary" @click="livePreview=true" style="margin-left:10px">Preview Booth Design</v-btn>
										<h2 style="margin-top:20px">Selected Template : </h2>
										<v-img :src="$root.asset(selectedLayoutImage)" eager></v-img>
								</div>
								<div v-else>
									<v-row>
										<v-col cols="8">
											<v-autocomplete
												v-model="layoutTagFilter"
												:items="layoutTagListFilter"
												chips
												small-chips
												deletable-chips
												label="Filter by tags"
												multiple
												solo
												dense
											></v-autocomplete>
										</v-col>
										<div style="display:flex;flex-direction:row;margin-top:13px;">
											<v-btn style="margin-right:10px" @click="filterLayout(false)" color="primary">filter</v-btn>
											<v-btn @click="resetLayout" color="primary">Reset</v-btn>
										</div>
									</v-row>
									<v-carousel hide-delimiters class="top" height="auto">
										<v-carousel-item v-for="(item, i) in layoutList" :key="i" eager>
											<v-img :src="$root.asset(item.dataMap.value)" contain eager>
												<v-btn v-if="item.id == selectedLayoutId" color="#0aabed">Selected Template</v-btn>
												<v-btn v-else @click="selectBoothTemplate(item)">Select This Template</v-btn>
											</v-img>
										</v-carousel-item>
									</v-carousel>
									<div class="d-flex justify-end top">
										<v-btn color="primary" v-if="selectedLayoutId!=null" @click="showLibrary=false">Cancel</v-btn>
									</div>
								</div>
							</v-card-text>
						</v-card>

						<v-card v-if="selectedLayoutId" elevation="0">
							<v-card-title style="font-size:30px;color:blue;">Graphics for the Banner Placeholders</v-card-title>
							<v-card-text v-if="bannerDataList">
								<span v-for="(item, idxItem) in bannerDataList" :key="idxItem">
									<h2>{{item.name}}</h2>
									<v-row>
										<v-col cols="12" md="2">
											<h3>Current Banner Image : </h3>
											<p>{{item.image}}</p>
											<p>Banner Image Type :</p>
												<v-radio-group
													v-model="item.bannerImageType"
													mandatory
												>
													<v-radio
														label="Stretch"
														value="100% 100%"
													></v-radio>
													<v-radio
														label="Cover"
														value="cover"
													></v-radio>
													<v-radio
														label="Contain"
														value="contain"
													></v-radio>
												</v-radio-group>
										</v-col>
										<v-col cols="12" md="3">
											<v-switch style="margin-top:-10px" v-model="item.imageType" :label="'Image Type : ' + (item.imageType ? 'URL' : 'Upload')"></v-switch>
											<v-btn
												v-if="!item.imageType"
												@click="
												openUpload('bannerImage',item);
												isUpload =true;
												"
											>Upload</v-btn>
											<v-text-field v-else v-model="item.image" label="Url"></v-text-field>
											<br v-if="!item.imageType" />
										</v-col>
										<v-col cols="12" md="2">
											<h3>Current Banner Value : </h3>
											<p>{{item.url}}</p>
										</v-col>
										<v-col cols="12" md="3">
											<v-switch style="margin-top:-10px" v-model="item.bannerType" :label="'Value Type : ' + (item.bannerType ? 'URL' : 'Upload')"></v-switch>
											<v-btn
												v-if="!item.bannerType"
												@click="
												openUpload('bannerUrl',item);
												isUpload =true;
												"
											>Upload</v-btn>
											<v-text-field v-else v-model="item.url" label="Url"></v-text-field>
										</v-col>
										<v-col cols="12" md="2">
											<h3>Open Link in</h3>
											<v-radio-group v-model="item.openLinkOption">
												<v-radio value="2">
													<template v-slot:label>
														Dialog &nbsp;
														<v-tooltip bottom>
															<template  v-slot:activator="{ on, attrs }">
																<v-icon v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
															</template>
															<span>Content will be viewed within a pop-up window within the live experience</span>
														</v-tooltip>
													</template>
												</v-radio>
												<v-radio value="1">
													<template v-slot:label>
														New Tab &nbsp;
														<v-tooltip bottom>
															<template  v-slot:activator="{ on, attrs }">
																<v-icon v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
															</template>
															<span>Content will immediately open in a new browser tab outside of the virtual experience without closing the virtual experience</span>
														</v-tooltip>
													</template>
												</v-radio>
												<v-radio value="3">
													<template v-slot:label>
														Current Tab &nbsp;
														<v-tooltip bottom>
															<template  v-slot:activator="{ on, attrs }">
																<v-icon v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
															</template>
															<span>Content will immediately open in the current browser tab, taking the User outside of the virtual experience</span>
														</v-tooltip>
													</template>
												</v-radio>
											</v-radio-group>
										</v-col>
									</v-row>
									<hr class="horizontal-line" />
								</span>
							</v-card-text>
						</v-card>

						<v-dialog v-if="livePreview" v-model="livePreview" scrollable fullscreen>
						<v-card elevation="0">
							<v-card-title class="headline">
								Preview Booth Design
								<v-spacer></v-spacer>
								<v-btn icon @click="livePreview=false">
									<v-icon>mdi-close</v-icon>
								</v-btn>
							</v-card-title>
							<v-card-text>
							<div style="display: inline-block; position: relative; min-width: 100%; overflow-x: auto" class="booth-img">
							<img
								style="width: auto; min-width:100%;right: 0, bottom:0;"
								:style="$vuetify.breakpoint.smAndDown ? 'height: 100vmax;' : 'height: calc(100vmax * (9/16));'"
								title
								:src="$root.asset(selectedLayoutImage)"
							/>
							<div v-if="bannerDataList">
								<div v-for="(banner, idxBanner) in bannerDataList" :key="idxBanner">
									<div v-if="banner.coordinateList" class="banner-place">
										<video
											v-if="banner.image && banner.image.endsWith('.mp4')"
											id="video"
											:style="{
												zIndex: 1,
												left: banner.coordinateList[0] + '%',
												top: banner.coordinateList[1] + '%',
												transform: banner.skewX
													? 'skew(' + banner.skewX + 'deg,' + banner.skewY + 'deg)'
													: 'skew(0deg, 0deg)',
												width: banner.coordinateList[2] + '%',
												height: banner.coordinateList[3] + '%',
												position: 'absolute'
											}"
											preload="auto"
											autoplay="autoplay"
											muted
											playsinline
											disablepictureinpicture
											loop="loop"
										>
											<source :src="$root.asset(banner.image)" type="video/mp4" />
										</video>
										<img
											v-if="banner.image && !banner.image.endsWith('.mp4')"
											:style="{
												zIndex: 1,
												left: banner.coordinateList[0] + '%',
												top: banner.coordinateList[1] + '%',
												transform: banner.skewX
													? 'skew(' + banner.skewX + 'deg,' + banner.skewY + 'deg)'
													: 'skew(0deg, 0deg)',
												width: banner.coordinateList[2] + '%',
												height: banner.coordinateList[3] + '%',
												position: 'absolute',
												objectFit: banner.bannerImageType, 
												backgroundColor: 'white'
											}"
											title
											:src="$root.asset(banner.image)"
										/>
										<a
											v-if="banner.url"
											:style="{
												zIndex: 2,
												left: banner.coordinateList[0] + '%',
												top: banner.coordinateList[1] + '%',
												transform: banner.skewX
													? 'skew(' + banner.skewX + 'deg,' + banner.skewY + 'deg)'
													: 'skew(0deg, 0deg)',
												width: banner.coordinateList[2] + '%',
												height: banner.coordinateList[3] + '%',
												position: 'absolute'
											}"
										></a>
									</div>
								</div>
							</div>
						</div>
							</v-card-text>
						</v-card>
					</v-dialog>

						<div class="d-flex justify-end top">
							<v-btn @click="prevStep(2)" color="#efefef" style="margin-right:10px">Previous</v-btn>
							<v-btn color="#0aabed" dark class="mb-2" @click="
									saveStep2();
									nextStep(2);
								">Save and Continue</v-btn>
						</div>
					</v-stepper-content>

					<v-stepper-content step="3">
						<!-- 	Content Links -->
						<v-card elevation="0">
							<v-card-title><h2 class="font-title">ADD YOUR CONTENT LINKS</h2></v-card-title>
							<v-card-text>
								<span class="font-desc">
									Next, you may add a number of Content Links (per your sponsorship level) directing your audience to external websites from your virtual exhibitor booth. This is the perfect place to include links to your corporate website, social media pages, job openings, marketing materials, or landing pages for special event discounts or downloads, etc.
									<br />
									<br />For the best user experience, we recommend no more than ten Content Links to be added per booth and each Content Link Title to be no more than 20 characters in length.
								</span>
							</v-card-text>
						</v-card>

						<v-card class="top" elevation="0">
							<v-img src="https://v-unite.com/wordpress/wp-content/uploads/2020/07/Nutrafol-Booth-Design.png"></v-img>
						</v-card>

						<v-card class="top" elevation="0">
							<v-card-text>
								<span v-for="(link, idxLink) in menuLink" :key="idxLink">
									<v-row>
										<v-col cols="12" md="3">
											<h3>Content Link Title</h3>
											<v-text-field v-model="link.title" outlined></v-text-field>
										</v-col>
										<v-col cols="12" md="3">
											<h3>Website/URL</h3>
											<v-text-field v-model="link.url" outlined></v-text-field>
										</v-col>
										<v-col cols="12" md="2">
											<v-switch v-model="link.status" :label="link.status ? 'Active' : 'Inactive'"></v-switch>
										</v-col>
										<v-col cols="12" md="2">
											<h3>Open Link in</h3>
											<v-radio-group v-model="link.openLinkOption" required row>
												<v-radio label="New Tab" value="1">
													<template v-slot:label>
														New Tab &nbsp;
														<v-tooltip bottom>
															<template  v-slot:activator="{ on, attrs }">
																<v-icon v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
															</template>
															<span>Content will immediately open in a new browser tab outside of the virtual experience without closing the virtual experience</span>
														</v-tooltip>
													</template>
												</v-radio>
												<v-radio label="Current Tab" value="2">
													<template v-slot:label>
														Current Tab &nbsp;
														<v-tooltip bottom>
															<template  v-slot:activator="{ on, attrs }">
																<v-icon v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
															</template>
															<span>Content will immediately open in the current browser tab, taking the User outside of the virtual experience</span>
														</v-tooltip>
													</template>
												</v-radio>
											</v-radio-group>
										</v-col>
										<v-col cols="12" md="1">
											<v-btn style="margin-top: 10px" @click="deleteExternalLink(link)">Delete</v-btn>
										</v-col>
									</v-row>
									<hr class="horizontal-line" />
								</span>
								<v-col v-if="entity.boothFeatureLimitList && entity.boothFeatureLimitList[0].limit == null" class="text-right">
									<v-btn color="#0aabed" dark class="mb-2" @click="addExternalLink()">Add another Link</v-btn>
								</v-col>
								<v-col v-else-if="entity.boothFeatureLimitList && menuLink.length < entity.boothFeatureLimitList[0].limit" class="text-right">
									<v-btn color="#0aabed" dark class="mb-2" @click="addExternalLink()">Add another Link</v-btn>
								</v-col>
							</v-card-text>
						</v-card>

						<div class="d-flex justify-end top">
							<v-btn @click="prevStep(3)" color="#efefef" style="margin-right:10px">Previous</v-btn>
							<v-btn color="#0aabed" dark class="mb-2" @click="
									saveStep3();
									nextStep(3);
								">Save and Continue</v-btn>
						</div>
					</v-stepper-content>

					<v-stepper-content step="4">
						<!-- Documents/Videos -->
						<v-card elevation="0">
							<v-card-title><h2 class="font-title">ADD YOUR DOCUMENTS AND VIDEOS</h2></v-card-title>
							<v-card-text>
								<span class="font-desc">
									You can add Documents (PDF, Word, Excel, Powerpoint) and Video Links (Youtube, Vimeo etc) to your booth. It's an ideal place to display your company information, brochures, and introductory videos.
									</span>
							</v-card-text>
						</v-card>

						<v-card class="top" elevation="0">
							<img src="https://v-unite.com/wordpress/wp-content/uploads/2020/10/Booth-Magnify-VideosCROP2.jpg" style="height:100%;width:100%" />
						</v-card>

						<v-card class="top" elevation="0">
							<v-card-title><b style="font-weight: 600 !important;">Please provide your Documents<br />(PDF, Word, Excel, Powerpoint)</b></v-card-title>
							<v-card-text>
								<v-radio-group v-model="haveDocument" mandatory>
									<v-radio label="Yes. I have documents that I'd like to add to my booth" value="true"></v-radio>
									<v-radio label="No. I don't have any documents to add" value="false"></v-radio>
								</v-radio-group>
								<span v-if="haveDocument == 'true'">
									<span v-for="(doc, idxDoc) in documents" :key="idxDoc">
										<v-row>
											<v-col cols="12" md="2">
												<h3>Document Title</h3>
												<v-text-field v-model="doc.title" :rules="[(v) => !!v || 'Title is required']" required></v-text-field>
											</v-col>
											<v-col cols="12" md="2">
												<h3>Current Value :</h3>
												<p>{{doc.value}}</p>
											</v-col>
											<v-col cols="12" md="2">
												<v-btn
													@click="
														openUpload('document',doc);
														isUpload =true;
													"
												>Upload File</v-btn>
											</v-col>
											<v-col cols="12" md="2">
												<h3>Open Link in</h3>
												<v-radio-group v-model="doc.dataMap.openLinkOption" row>
													<v-radio label="Dialog" value="2">
														<template v-slot:label>
															Dialog &nbsp;
															<v-tooltip bottom>
																<template  v-slot:activator="{ on, attrs }">
																	<v-icon v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
																</template>
																<span>Content will be viewed within a pop-up window within the live experience</span>
															</v-tooltip>
														</template>
													</v-radio>
													<v-radio label="New Tab" value="1">
														<template v-slot:label>
															New Tab &nbsp;
															<v-tooltip bottom>
																<template  v-slot:activator="{ on, attrs }">
																	<v-icon v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
																</template>
																<span>Content will immediately open in a new browser tab outside of the virtual experience without closing the virtual experience</span>
															</v-tooltip>
														</template>
													</v-radio>
												</v-radio-group>
											</v-col>
											<v-col cols="12" md="2">
												<v-switch v-model="doc.status" :label="doc.status ? 'Active' : 'Inactive'"></v-switch>
											</v-col>
											<v-col cols="12" md="2">
												<v-btn  @click="deleteDocument(doc)">Delete</v-btn>
											</v-col>
										</v-row>
										<hr class="horizontal-line" />
									</span>
									<v-col v-if="entity.boothFeatureLimitList && entity.boothFeatureLimitList[1].limit == null" class="text-right">
										<v-btn color="#0aabed" dark class="mb-2" @click="addDocument()">Add another Document</v-btn>
									</v-col>
									<v-col v-else-if="entity.boothFeatureLimitList && documents.length < entity.boothFeatureLimitList[1].limit" class="text-right">
										<v-btn color="#0aabed" dark class="mb-2" @click="addDocument()">Add another Document</v-btn>
									</v-col>
								</span>
							</v-card-text>
						</v-card>

						<v-card class="top" elevation="0">
							<v-card-title><b style="font-weight: 600 !important;">Please provide your Video Links<br />(Youtube/Vimeo/etc)</b></v-card-title>
							<v-card-text>
								<v-radio-group v-model="haveVideo" mandatory>
									<v-radio label="Yes. I have documents that I'd like to add to my booth" value="true"></v-radio>
									<v-radio label="No. I don't have any documents to add" value="false"></v-radio>
								</v-radio-group>
								<span v-if="haveVideo == 'true'">
									<span v-for="(video, idxVideo) in videos" :key="idxVideo">
										<v-row>
											<v-col cols="12" md="2">
												<h3>Video Title</h3>
												<v-text-field v-model="video.title" :rules="[(v) => !!v || 'Title is required']" required></v-text-field>
											</v-col>
											<v-col cols="12" md="2">
												<h3>Current Value : </h3>
												<p>{{video.value}}</p>
											</v-col>
											<v-col cols="12" md="2">
												<v-switch v-model="video.dataMap.docType" :label="'Type : ' + (video.dataMap.docType ? 'URL' : 'Upload')"></v-switch>
												<v-btn
													v-if="!video.dataMap.docType"
													@click="
														openUpload('video',video);
														isUpload=true;
													"
												>Upload</v-btn>
												<v-text-field v-else v-model="video.value" label="Url"></v-text-field>
											</v-col>
											<v-col cols="12" md="2">
												<h3>Open Link in</h3>
												<v-radio-group v-model="video.dataMap.openLinkOption" row>
													<v-radio label="Dialog" value="2">
														<template v-slot:label>
															Dialog &nbsp;
															<v-tooltip bottom>
																<template  v-slot:activator="{ on, attrs }">
																	<v-icon v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
																</template>
																<span>Content will be viewed within a pop-up window within the live experience</span>
															</v-tooltip>
														</template>
													</v-radio>
													<v-radio label="New Tab" value="1">
														<template v-slot:label>
															New Tab &nbsp;
															<v-tooltip bottom>
																<template  v-slot:activator="{ on, attrs }">
																	<v-icon v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
																</template>
																<span>Content will immediately open in a new browser tab outside of the virtual experience without closing the virtual experience</span>
															</v-tooltip>
														</template>
													</v-radio>
												</v-radio-group>
											</v-col>
											<v-col cols="12" md="2">
												<v-switch v-model="video.status" :label="video.status ? 'Active' : 'Inactive'"></v-switch>
											</v-col>
											<v-col cols="12" md="2">
												<v-btn @click="deleteVideo(video)">Delete</v-btn>
											</v-col>
										</v-row>
										<hr class="horizontal-line" />
									</span>
									<v-col v-if="entity.boothFeatureLimitList && entity.boothFeatureLimitList[2].limit == null" class="text-right">
										<v-btn color="#0aabed" dark class="mb-2" @click="addVideo()">Add another Video</v-btn>
									</v-col>
									<v-col v-else-if="entity.boothFeatureLimitList && videos.length < entity.boothFeatureLimitList[2].limit" class="text-right">
										<v-btn color="#0aabed" dark class="mb-2" @click="addVideo()">Add another Video</v-btn>
									</v-col>
								</span>
							</v-card-text>
						</v-card>
						<div class="d-flex justify-end top">
							<v-btn @click="prevStep(4)" color="#efefef" style="margin-right:10px">Previous</v-btn>
							<v-btn color="#0aabed" dark class="mb-2" @click="
									saveStep4();
								">Save and Continue</v-btn>
						</div>
					</v-stepper-content>

					<v-dialog v-model="isUpload" width="400">
						<v-card>
							<v-card-text>
								<v-file-input
									v-if="uploadType == 'bannerImage'"
									v-model="attachment1"
									label
									placeholder="Drop files here to upload (image/video)"
									prepend-icon="mdi-attachment"
									accept="image/png, image/jpeg, image/jpg, video/mp4"
									:show-size="1000"
								></v-file-input>
								<v-file-input
									v-else
									v-model="attachment1"
									label
									placeholder="Drop files here to upload"
									prepend-icon="mdi-attachment"
									accept="application/pdf, video/mp4"
									:show-size="1000"
								></v-file-input>
							</v-card-text>
							<v-card-actions>
								<v-btn v-if="uploadType=='video' || uploadType =='document'" @click="uploadType == 'video' ? upload('video') : upload('document')">Save</v-btn>
								<v-btn v-else @click="uploadType == 'bannerUrl' ? upload('bannerUrl') : upload('bannerImage')">Save</v-btn>
								<v-btn @click="
											attachment1 = null;
											isUpload = false;
											uploadType= null;
										">Cancel</v-btn>
							</v-card-actions>
						</v-card>
					</v-dialog>

					<v-stepper-content step="5">
						<!-- Booth Rep -->
						<v-card>
							<v-card-title><h2 class="font-title">CREATE YOUR BOOTH REP ACCOUNTS</h2></v-card-title>
							<v-card-text>
								<span class="font-desc">
									During the live event, we usually recommend having a couple of team members available online to interact with the attendees via chat.
									<br /><br />
									All we need is their name and email address, and we'll create Booth Rep accounts for them. Each rep can then login with their own accounts when the event goes live.
									<br /><br />
									You can also provide the date and times each rep will be online and available to chat with attendees. A schedule will be displayed on the booth so that attendees know when to expect you.
									<br /><br />
									Alternatively, you have the option to turn off the chat functionality in Step 1 of this form.
									</span>
									<br /><br />
									<v-card color="#f2f5f7" style="padding:20px">
										<v-card-text style="font-size:14px; font-family:'Lucida Grande','Lucida Sans Unicode',Tahoma,sans-serif">
											We always recommend having a prefix before the first name that identifies you as a rep from your company. See some examples below:
											<br /><br />
											Microsoft HR Rep John Smith<br />Dell Booth Rep John Smith<br/>Admissions Counselor Jamie etc
											<br /><br />
											Since we do not host any sensitive information from our events, we will be emailing you a few days prior to the live event with an email confirmation that includes a link to create your own password to access the live event.
										</v-card-text>
									</v-card>
							</v-card-text>
						</v-card>

						<v-card elevation="0">
							<v-card-text>
								<v-simple-table>
									<template v-slot:top>
										<v-toolbar flat color="white">
											<v-toolbar-title>Booth Rep List</v-toolbar-title>
											<v-spacer></v-spacer>
											<v-btn v-if="entity.boothFeatureLimitList && entity.boothFeatureLimitList[3].limit == null" color="#0aabed" dark class="mb-2" @click="addBoothRep()">Add</v-btn>
											<v-btn v-else-if="entity.boothFeatureLimitList && boothRepList.length < entity.boothFeatureLimitList[3].limit" color="#0aabed" dark class="mb-2" @click="addBoothRep()">Add</v-btn>
										</v-toolbar>
									</template>
									<template>
										<thead>
											<tr>
												<th class="text-left">First Name</th>
												<th class="text-left">Last Name</th>
												<th class="text-left">Email</th>
												<th class="text-left">Actions</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(item, idxItem) in boothRepList" :key="idxItem">
												<td>{{ item.firstName}}</td>
												<td>{{ item.lastName }}</td>
												<td>{{ item.email }}</td>
												<td>
													<v-icon small class="mr-2" title="Edit" @click="editBoothRep(item)">mdi-pencil</v-icon>
													<v-icon small @click="showDeleteDialog(item)">mdi-delete</v-icon>
												</td>
											</tr>
										</tbody>
									</template>
								</v-simple-table>
							</v-card-text>
						</v-card>

						<v-dialog v-model="showAddBoothRep" v-if="showAddBoothRep" width="360">
							<v-form ref="form" v-model="valid" @submit.prevent="nextBoothRep" v-if="inputEmail">
								<v-card>
									<v-card-title>Add Booth Rep Account</v-card-title>
									<v-card-text>
										<v-text-field v-model="boothRepEmail" :rules="emailRules" label="E-mail" required></v-text-field>
									</v-card-text>
									<v-divider></v-divider>
									<v-card-actions class="py-4">
										<v-spacer></v-spacer>
										<v-btn :disabled="!valid" type="submit" color="#0aabed" depressed tile>Next</v-btn>
										<v-btn depressed tile @click="closeAddBoothRep">Cancel</v-btn>
									</v-card-actions>
								</v-card>
							</v-form>

							<v-form ref="form" v-model="valid" @submit.prevent="saveBoothRep" v-if="inputData">
								<v-card>
									<v-card-title>Add Booth Rep Account</v-card-title>
									<v-card-text>
										<v-text-field v-model="boothRep.firstName" label="First Name" filled readonly v-if="!editData"></v-text-field>
										<v-text-field v-model="boothRep.lastName" label="Last Name" filled readonly v-if="!editData"></v-text-field>
										<v-text-field v-model="boothRep.title" label="Title" filled readonly v-if="!editData"></v-text-field>
										<v-textarea v-model="boothRep.bio" label="Bio" filled readonly v-if="!editData"></v-textarea>
										<v-text-field v-model="boothRep.firstName" label="First Name" required v-if="editData"></v-text-field>
										<v-text-field v-model="boothRep.lastName" label="Last Name" required v-if="editData"></v-text-field>
										<v-text-field v-model="boothRep.title" label="Title" required v-if="editData"></v-text-field>
										<v-text-field v-model="boothRep.password" label="Password" type="password" autocomplete="new-password" required v-if="editData"></v-text-field>
										<v-textarea v-model="boothRep.bio" label="Bio" required v-if="editData"></v-textarea>
									</v-card-text>
									<v-divider></v-divider>
									<v-card-actions class="py-4">
										<v-spacer></v-spacer>
										<v-btn :disabled="!valid" type="submit" color="#0aabed" depressed tile>Save</v-btn>
										<v-btn color="grey" depressed tile @click="closeAddBoothRep">Cancel</v-btn>
									</v-card-actions>
								</v-card>
							</v-form>
						</v-dialog>

						<v-dialog v-model="showEditBoothRep" v-if="showEditBoothRep" width="360">
							<v-card>
								<v-icon title="close" @click="closeAddBoothRep()" style="float:right;">mdi-close</v-icon>
								<v-card-title>
									<span>Edit Booth Rep</span>
								</v-card-title>
								<v-card-text>
									<v-form v-model="valid" ref="formBoothRep" @submit.prevent="updateBoothRep">
										<div v-if="showEditBoothRep">
											Current Booth Rep:
											<br />
											<span>
												{{experienceUser.email}}
												<br />
											</span>
										</div>

										<v-text-field
											v-model="boothRep.dataMap.availability"
											label="Availability"
											hint="Example : Friday 9am - 5pm est"
											persistent-hint
											style="margin-top:15px;"
										></v-text-field>

										<div class="d-flex justify-end">
											<v-btn color="blue darken-1" text @click="closeAddBoothRep()">Cancel</v-btn>
											<v-btn :disabled="!valid" color="blue darken-1" type="submit">Save</v-btn>
										</div>
									</v-form>
								</v-card-text>
							</v-card>
						</v-dialog>
						<v-dialog v-model="dialogDelete" v-if="dialogDelete" max-width="500px">
							<v-card>
								<v-card-title>Delete</v-card-title>
								<v-card-text>Are you sure you want to delete?</v-card-text>
								<v-card-actions>
									<v-btn color="grey" text @click="dialogDelete = false;">Close</v-btn>
									<v-btn color="#0aabed" text @click="deleteBoothRep()">Delete</v-btn>
								</v-card-actions>
							</v-card>
						</v-dialog>
						<div class="d-flex justify-end top">
							<v-btn @click="prevStep(5)" color="#efefef" style="margin-right:10px">Previous</v-btn>
							<v-btn color="#0aabed" dark class="mb-2" @click="
									nextStep(5);
								">Continue</v-btn>
						</div>
					</v-stepper-content>

					<v-stepper-content  step="6">
						<!-- Review/Publish -->
						<v-card>
							<v-card-title><b class="font-title">ALMOST DONE!</b></v-card-title>
							<v-card-text>
								<span>
									<b style="font-size:21px; font-weght: 600 !important; line-height: 1.1">
										Once you press the SUBMIT button below, the information will automatically be added to the live experience platform. Please ensure that all of the information provided is complete and accurate to the best of your knowledge.
									</b>
									<br /><br />
									<p class="font-desc">
										If you need to make any changes or additions to your booth at any time, please use the same unique booth set up link and be sure to submit your work on Step 6 to submit your changes.
									</p>
								</span>
							</v-card-text>
						</v-card>
						<div class="d-flex justify-end top">
							<v-btn @click="showPreview = !showPreview" color="#0aabed" dark style="margin-right:10px">View Live Booth</v-btn>
							<v-btn @click="prevStep(6)" color="#efefef" style="margin-right:10px">Previous</v-btn>
							<v-btn color="#0aabed" dark class="mb-2" @click="
									saveStep6(6);
								">Submit</v-btn>
						</div>
						

						<div v-if="showPreview">
							<div id="structure-view">
								<div class="entry-view">
									<div
										style="display: inline-block; position: relative; min-width: 100%; overflow: hidden"
										:style="{
											backgroundImage: 'url(' + $root.asset(entity.boothBackgroundImage) + ')',
											backgroundSize: 'cover',
											backgroundPosition: 'center',
											backgroundRepeat: 'no-repeat',
											maxHeight: $vuetify.breakpoint.smAndDown ? '100vmax !important;' : 'calc(100vmax * (9/16)) !important;'
										}"
									>
							
										<div style="display: inline-block; position: relative; min-width: 100%; overflow-x: auto" class="booth-img">
											<img
												style="width: 800px; min-width:100%;right: 0, bottom:0;"
												:style="$vuetify.breakpoint.smAndDown ? 'height: 100vmax;' : 'height: calc(100vmax * (9/16));'"
												title
												:src="$root.asset(selectedLayoutImage)"
											/>
											<div v-if="entity.bannerList">
												<div v-for="(banner, idxBanner) in entity.bannerList" :key="idxBanner">
													<div v-if="banner.coordinateList" class="banner-place">
														<video
															v-if="banner.image && banner.image.endsWith('.mp4')"
															id="video"
															:style="{
																zIndex: 1,
																left: banner.coordinateList[0] + '%',
																top: banner.coordinateList[1] + '%',
																transform: banner.skewX
																	? 'skew(' + banner.skewX + 'deg,' + banner.skewY + 'deg)'
																	: 'skew(0deg, 0deg)',
																width: banner.coordinateList[2] + '%',
																height: banner.coordinateList[3] + '%',
																position: 'absolute'
															}"
															preload="auto"
															autoplay="autoplay"
															muted
															playsinline
															disablepictureinpicture
															loop="loop"
														>
															<source :src="$root.asset(banner.image)" type="video/mp4" />
														</video>
														<img
															v-if="banner.image && !banner.image.endsWith('.mp4')"
															:style="{
																zIndex: 1,
																left: banner.coordinateList[0] + '%',
																top: banner.coordinateList[1] + '%',
																transform: banner.skewX
																	? 'skew(' + banner.skewX + 'deg,' + banner.skewY + 'deg)'
																	: 'skew(0deg, 0deg)',
																width: banner.coordinateList[2] + '%',
																height: banner.coordinateList[3] + '%',
																position: 'absolute',
																objectFit: banner.bannerImageType, 
																backgroundColor: 'white'
															}"
															title
															:src="$root.asset(banner.image)"
														/>
														<a
															v-if="banner.url && banner.openLinkOption == '1'"
															:style="{
																zIndex: 2,
																left: banner.coordinateList[0] + '%',
																top: banner.coordinateList[1] + '%',
																transform: banner.skewX
																	? 'skew(' + banner.skewX + 'deg,' + banner.skewY + 'deg)'
																	: 'skew(0deg, 0deg)',
																width: banner.coordinateList[2] + '%',
																height: banner.coordinateList[3] + '%',
																position: 'absolute'
															}"
															:href="banner.url.startsWith('http') ? banner.url : $root.asset(banner.url)"
															target="_blank"
															@click="visitBoothBanner(banner)"
														></a>
														<a
															v-if="banner.url && banner.openLinkOption == '2'"
															:style="{
																zIndex: 2,
																left: banner.coordinateList[0] + '%',
																top: banner.coordinateList[1] + '%',
																transform: banner.skewX
																	? 'skew(' + banner.skewX + 'deg,' + banner.skewY + 'deg)'
																	: 'skew(0deg, 0deg)',
																width: banner.coordinateList[2] + '%',
																height: banner.coordinateList[3] + '%',
																position: 'absolute'
															}"
															@click="showBanner(banner)"
															style="text-decoration: none"
														></a>
														<a
															v-if="banner.url && banner.openLinkOption == '3'"
															:style="{
																zIndex: 2,
																left: banner.coordinateList[0] + '%',
																top: banner.coordinateList[1] + '%',
																transform: banner.skewX
																	? 'skew(' + banner.skewX + 'deg,' + banner.skewY + 'deg)'
																	: 'skew(0deg, 0deg)',
																width: banner.coordinateList[2] + '%',
																height: banner.coordinateList[3] + '%',
																position: 'absolute'
															}"
															:href="banner.url.startsWith('http') ? banner.url : $root.asset(banner.url)"
															@click="visitBoothBanner(banner)"
														></a>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div v-if="showBannerPopup">
								<v-dialog v-model="showBannerPopup" content-class="v-dialog--custom" persistent>
									<v-card height="90vh">
										<v-card-title>
											<span class="headline"></span>
											<v-spacer></v-spacer>
											<v-icon
												@click="
													showBannerPopup = false;
													iframeBanner = false;
												"
												>mdi-close</v-icon
											>
										</v-card-title>
										<iframe
											v-if="iframeBanner"
											frameborder="0"
											allow="autoplay; encrypted-media"
											scrolling="0"
											width="100%"
											class="iframe-size"
											:src="$root.asset(entity.bannerList[currentIndex].url)"
											allowfullscreen
											style="height:93%"
										></iframe>
									</v-card>
								</v-dialog>
							</div>

							<div class="main-large d-flex flex-column">
								<v-row class="mx-0">
									<v-col cols="12" class="pa-0">
										<v-card tile width="100%" color="#416D74" elevation="0" class="card-height" flat v-if="entity.boothFeatureList.length > 0">
											<v-card-title>
												<h2 class="booth-name">{{ entity.name }}</h2>
											</v-card-title>
											<div style="margin-left: 40px; margin-right: 20px">
												<div class="box hidden-sm-and-down">
													<div class="first-item">
														<ul id="detail-nav" style="margin-top: 10px">
															<li v-for="(tab, idxTab) in boothFeatures" :key="idxTab">
																<a @click="setActive(tab)" v-if="tab.status">
																	<v-icon color="white" small>{{ tab.icon }}</v-icon>
																	&nbsp;{{ tab.tabTitle }}
																</a>
																<hr
																	v-bind:class="{
																		active: active === tab.tabTitle
																	}"
																	v-if="active == tab.tabTitle && tab.status"
																/>
																<hr class="title-line" v-if="active != tab.tabTitle && tab.status" />
															</li>
														</ul>
													</div>
													<div class="second-item">
														<h2 style="color: white; margin-top: 58px"></h2>
														<hr class="title-line" />
													</div>
												</div>

												<div class="hidden-md-and-up">
													<v-card color="#416D74" flat style="margin-right: 20px">
														<v-card-title color="#416D74">
															<v-toolbar-title style="color: white">
																<v-icon style="color: white; margin-right: 20px">{{ iconActive }}</v-icon>
																{{ active }}
															</v-toolbar-title>

															<v-spacer></v-spacer>

															<v-menu bottom left absolute color="#416D74" max-width="300">
																<template v-slot:activator="{ on, attrs }">
																	<v-btn dark icon v-bind="attrs" v-on="on">
																		<v-icon>mdi-menu</v-icon>
																	</v-btn>
																</template>

																<v-list color="#416D74" outlined width="300px" height="100%">
																	<v-template v-for="(item, i) in boothFeatures" :key="i">
																		<v-list-item @click="setActive(item)" v-if="item.status">
																			<v-list-item-icon>
																				<v-icon style="color: white" v-text="item.icon"></v-icon>
																			</v-list-item-icon>
																			<v-list-item-title style="color: white">
																				{{ item.tabTitle }}
																				<hr class="title-line" />
																			</v-list-item-title>
																		</v-list-item>
																	</v-template>
																</v-list>
															</v-menu>
														</v-card-title>
														<hr style="border: 1.5px solid white; background-color: white" />
													</v-card>
												</div>

												<v-card color="#416D74" dark height="400" elevation="0" class="scroll content-card">
													<span v-if="active == entity.boothFeatureList[0].tabTitle">
														<div style="margin-top: 20px" v-html="entity.description"></div>
													</span>
													<span v-if="active == entity.boothFeatureList[2].tabTitle">
														<ul v-for="(video, idxVideo) in videos" :key="idxVideo" id="feature">
															<li style="display: flex; flex-direction: row; justify-content: space-between">
																<div style="display: flex; flex-direction: row; justify-content: space-between">
																	<span>
																		<v-icon small>mdi-play-circle-outline</v-icon>
																		{{ video.title }}
																	</span>
																</div>
																<v-btn
																	v-if="video.dataMap.openLinkOption && video.dataMap.openLinkOption == '1'"
																	color="orange"
																	rounded
																	small
																	width="15"
																>
																	<a
																		target="_blank"
																		style="background-color: transparent; text-transform: none; text-decoration: none"
																		:href="$root.asset(video.value)"
																		>View</a
																	>
																</v-btn>
																<v-btn
																	v-else
																	@click="openDocuments(video, 'video')"
																	color="orange"
																	rounded
																	small
																	width="15"
																	style="text-transform: none"
																	>View</v-btn
																>
															</li>
															<hr class="horizontal-line" />
														</ul>
													</span>

													<span v-if="active == entity.boothFeatureList[1].tabTitle">
														<ul v-for="(doc, idxDoc) in documents" :key="idxDoc" id="feature">
															<li style="display: flex; flex-direction: row; justify-content: space-between">
																<div style="display: flex; flex-direction: row; justify-content: space-between">
																	<span>
																		<v-icon small>mdi-file-pdf</v-icon>
																		{{ doc.title }}
																	</span>
																</div>
																<div style="display: flex; flex-direction: row; justify-content: space-between">
																	<v-btn
																		class="hidden-sm-and-down"
																		rounded
																		style="text-transform: none; color: white; margin-right: 10px"
																		color="#416D74"
																		outlined
																		height="100%"
																		>Save to My Documents</v-btn
																	>
																	<v-icon class="hidden-md-and-up" style="margin-right: 20px"
																		>mdi-content-save</v-icon
																	>
																	<v-btn
																		v-if="doc.dataMap.openLinkOption && doc.dataMap.openLinkOption == '1'"
																		color="orange"
																		rounded
																		small
																		width="15"
																	>
																		<a
																			target="_blank"
																			style="background-color: transparent; text-transform: none; text-decoration: none"
																			:href="$root.asset(doc.value)"
																			>View</a
																		>
																	</v-btn>
																	<v-btn
																		v-else
																		@click="openDocuments(doc, 'document')"
																		color="orange"
																		rounded
																		small
																		width="15"
																		style="text-transform: none"
																		>View</v-btn
																	>
																</div>
															</li>
															<hr class="horizontal-line" />
														</ul>
													</span>

													<span v-if="active == entity.boothFeatureList[3].tabTitle">
														<ul id="feature" v-for="(menuLink, idxMenuLink) in entity.menuLinkList" :key="idxMenuLink">
															<li style="display: flex; flex-direction: row; justify-content: space-between">
																<a
																	v-if="menuLink.openLinkOption == 1 && menuLink.status"
																	:href="menuLink.url"
																	target="_blank"
																	style="text-decoration: none"
																	>{{ menuLink.title }}</a
																>
																<a
																	v-if="menuLink.openLinkOption == 2 && menuLink.status"
																	:href="menuLink.url"
																	style="text-decoration: none"
																	>{{ menuLink.title }}</a
																>
															</li>
															<hr class="horizontal-line" v-if="menuLink.status" />
														</ul>
													</span>
													<span v-if="active == entity.boothFeatureList[4].tabTitle">
														<ul id="feature" v-for="(boothRep, idxBoothRep) in boothRepList" :key="idxBoothRep">
															<li>
																{{ boothRep.firstName }}
																{{ boothRep.lastName }}
																{{ boothRep.dataMap.availability == "" || !boothRep.dataMap.availability ? "" : "-" }}
																{{ boothRep.dataMap.availability }}
															</li>
														</ul>
													</span>
													<span v-if="active == entity.boothFeatureList[5].tabTitle">
														<v-text-field
															v-model="searchParam"
															@keyup="searchProduct"
															class="mx-4"
															label="Search Products by name or item number"
															append-icon="mdi-close-circle-outline"
															prepend-inner-icon="mdi-magnify"
															full-width
															@click:append="clearSearch"
															solo
															flat
															dense
														></v-text-field>
														<v-simple-table class="hidden-sm-and-down" style="background-color: #416d74">
															<template v-slot:default>
																<thead>
																	<tr>
																		<th class="text-left">SKU #</th>
																		<th class="text-left">Title</th>
																		<th class="text-left">Product Category</th>
																		<th class="text-left">Price</th>
																	</tr>
																</thead>
																<tbody>
																	<tr v-for="(item, idxItem) in productList" :key="idxItem">
																		<td>{{ item.sku }}</td>
																		<td>{{ item.title }}</td>
																		<td>{{ item.productCategory }}</td>
																		<td>${{ item.price }}</td>
																	</tr>
																</tbody>
															</template>
														</v-simple-table>
														<ul class="hidden-md-and-up">
															<li v-for="(item, idxItem) in productList" :key="idxItem">
																<span style="display: flex; flex-direction: row; justify-content: space-between">
																	<p>{{ item.sku }}</p>
																	<p>{{ item.productCategory }}</p>
																	<p>${{ item.price }}</p>
																</span>
																<p>{{ item.title }}</p>
																<hr class="title-class" />
															</li>
														</ul>
													</span>
												</v-card>
											</div>
										</v-card>
									</v-col>
								</v-row>

							<v-dialog v-model="showDocument" content-class="v-dialog--custom" persistent>
								<v-card v-if="selectedDocument != null">
									<v-card-title>
										<span class="headline">{{ selectedDocument.title }}</span>
										<v-spacer></v-spacer>
										<v-icon @click="closeDoc">mdi-close</v-icon>
									</v-card-title>
									<iframe
										v-if="iframeDoc"
										frameborder="0"
										allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
										scrolling="0"
										width="100%"
										class="iframe-size"
										:src="$root.asset(selectedDocument.value)"
										allowfullscreen
									></iframe>
								</v-card>
							</v-dialog>
						</div>
						</div>
					</v-stepper-content>
				</v-stepper-items>
			</v-stepper>

			<v-dialog v-model="showDialogHelp" content-class="col-sm-6 col-12 hide-box-shadow" persistent>
				<v-card rounded="xl" dark color="#363636">
					<v-card-title>
						<span style="font-size: 14px" class="d-flex justify-center">
							<v-icon medium>mdi-help-circle-outline</v-icon>
							<span class="ml-2">Help</span>
						</span>
						<v-spacer></v-spacer>
						<v-icon @click="isSendMessage= false;showDialogHelp = false">mdi-close-circle-outline</v-icon>
					</v-card-title>
					<v-divider class="mx-4"></v-divider>
					<v-card-text v-if="!isSendMessage" style="margin-top:20px">
						<form @submit.prevent="sendMessage">
							<v-text-field label="Your Email" v-model="email" :rules="[(v) => !!v || 'Your email is required']" required></v-text-field>
							<v-textarea label="Message" v-model="message" :rules="[(v) => !!v || 'Message is required']" required></v-textarea>
							<div class="d-flex justify-end">
								<v-btn type="submit">SEND</v-btn>
							</div>
						</form>
					</v-card-text>
					<v-card-text v-else style="margin-top:20px">
						<h3>Thank you for contacting our V-Unite support team! One of our team members will be in touch as soon as possible to address this issue. </h3>
						<br>
						<h3> The V-Unite Team </h3>
					</v-card-text>
				</v-card>
			</v-dialog>
			
			<v-dialog v-model="$store.state.notification.show" width="500">
				<v-card style="padding: 20px">
					<!-- <div style="display: flex; justify-content: space-between">
						<h2 style="margin-bottom: 10px">Whoops! ({{ $store.state.notification.title }})</h2>
						<v-btn icon color="secondary" @click="closeNotification">
							<v-icon>mdi-close</v-icon>
						</v-btn>
					</div> -->

					<div class="text-center mb-5">
						<h2 style="margin-bottom: 10px; font-size: larger;"
						>Something Went Wrong</h2>
					</div>

					<template v-if="$store.state.notification.content && $store.state.notification.content.type == 'NOTIFICATION'">
						<div class="text-center" style="color: #c42126; font-size: 14px" :key="idxItem" v-for="(item, idxItem) in $store.state.notification.content.fieldErrorList">{{ item }}</div>
						<div class="text-center" style="color: #ed5025; font-size: 14px" :key="idxItem" v-for="(item, idxItem) in $store.state.notification.content.errorList">{{ item }}</div>
						<div class="text-center" style="color: #e26026; font-size: 14px" :key="idxItem" v-for="(item, idxItem) in $store.state.notification.content.noticeList">{{ item }}</div>
					</template>
					<template v-else>
						<div class="text-center" style="color: #e26026; font-size: 14px">{{ $store.state.notification.content }}</div>
					</template>
					<div class="text-center mt-5 mr-10 ml-10">
						<p style="font-size: 10px; font-weight: bold;">If this issue persists please contact us through our email with a screenshot at <span 
						style="color:blue; text-decoration: underline;">support@v-unite.com</span></p>
					</div>
					<div style="text-align: center; margin-top: 20px">
						<v-btn color="#009ec1" @click="closeNotification">Close</v-btn>
					</div>
				</v-card>
			</v-dialog>

			<v-divider></v-divider>
			<v-snackbar v-model="snackbar">
				{{ snackbarContent }}
				<template v-slot:action="{ attrs }">
					<v-btn color="red" text v-bind="attrs" @click="snackbar = false">Close</v-btn>
				</template>
			</v-snackbar>
		</v-container>
		<v-overlay style="z-index: 999;" :value="$root.loader.value" opacity="0">
			<img :src="baseLocation + '/resource/image/loader.svg'" class="loader" />
		</v-overlay>
	</v-app>
</template>


<style scoped>
.top {
	margin-top: 20px;
}
.horizontal-line {
	width: 100%;
	border-top: 0px;
}
.font-title{
	font-family: 'Montserrat', sans-serif;
    margin: 0 0 15px 0;
    color: #003366;
	font-weight: 800;
    text-transform: uppercase;
    margin-bottom: 20px;
	font-size: 30px;
}
.font-desc{
	font-size: 21px;
	font-weight: 300;
    line-height: 1.4;
	color: #666666;
	font-family: Lucida Grande,Lucida Sans Unicode,Tahoma,sans-serif;
}
.page-title{
	margin-top: 0;
    text-align: left;
    color: #333333;
    margin-bottom: 0;
	font-size: 40px;
    font-weight: 800;
    text-transform: uppercase;
	font-family: 'Montserrat', sans-serif;
    margin: 0 0 15px 0;
	display: block;
	line-height: 1.1;
	margin-left: 5%;
}
#structure-view .entry-view {
	overflow-x: auto;
	overflow-y: auto;
	width: auto;
	max-width: 100%;
	height: auto;
	margin: 0 auto;
}
.entry-view {
	/* position: relative; */
	margin: 0;
}
.ellipsis {
	position: relative;
	padding: 0;
}

.ellipsis span {
	position: absolute;
	left: 0;
	right: 0;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.scrollable {
	overflow-y: auto;
	overflow-x: hidden;
	height: 50vh;
}

#callScreen {
	width: 500px;
	height: 500px;
}

/* Let's get this party started */
::-webkit-scrollbar {
	height: 2px;
	background-color: rgba(65, 109, 116, 1);
	width: 3px;
}

/* Track */
::-webkit-scrollbar-track {
	-webkit-border-radius: 10px;
	border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
	-webkit-border-radius: 10px;
	border-radius: 10px;
	background: grey;
}
.booth-name {
	color: white;
	font-size: 20px;
	margin-top: 15px;
	margin-left: 40px;
	margin-right: 20px;
}
.card-height {
	height: 600px;
}
.main-large {
	width: 100%;
}
.v-dialog--custom {
	width: 800px;
	height: 510px;
}
.iframe-size {
	height: 450px;
}
.bg-img {
	width: auto;
	min-width: 100%;
	right: 0;
	bottom: 0;
}
.scroll {
	overflow-y: auto;
}
.scroll-x {
	overflow-x: auto;
}
ul#feature {
	background: #416d74;
	padding: 10px;
}
ul#feature li a {
	margin: 0px;
	padding: 5px;
	color: white;
}
ul#detail-nav {
	list-style-type: none;
	margin: 0;
	padding: 0;
	overflow: hidden;
	background-color: #416d74;
}
ul#detail-nav li {
	float: left;
}
ul#detail-nav li a {
	display: block;
	color: white;
	text-align: center;
	padding: 12px 14px;
	text-decoration: none;
}
.active {
	border: 1px solid orange;
	border: 0.5px solid orange;
	background-color: orange;
}
.title-line {
	border: 0.5px solid white;
	background-color: white;
}
.box {
	display: flex;
}
.second-item {
	flex: 1 1 0;
}
.first-item {
	flex: 0 1 auto;
}
li a:hover {
	background-color: #416d74;
}
li {
	display: block;
}
.lyt-imgs-cog {
	border: 0px solid;
}
.body-container {
	width: auto;
	max-width: 100%;
	height: auto;
	position: relative;
}
img {
	/* vertical-align: middle; */
	text-align: center;
}
.horizontal-line {
	margin-top: 10px;
}
</style>

<script>
import axios from "axios";
import Editor from "@tinymce/tinymce-vue";

export default {
	props: ["boothSetupId", "tenantId", "tenantPlanId", "experienceId"],
	components: {
		editor: Editor
	},
	data: () => ({
		e1: 1,
		steps: 7,
		baseLocation: axios.defaults.baseURL,
		valid: true,
		logoType: true,
		emailRules: [v => !!v || "E-mail is required", v => /.+@.+\..+/.test(v) || "E-mail must be valid"],
		linkIndex: null,
		entity: { dataMap: {}, transitMap: {}, bannerList: [], logo:"" },
		attachment1: null,
		attachment2: null,
		attachment3: null,
		attachment: null,
		items: [
			{
				src: axios.defaults.baseURL + "/resource/image/booth-submission/2021/05/V-Unite%20booth_for%20form.png"
			},
			{
				src: axios.defaults.baseURL + "/resource/image/booth-submission/2021/05/PAPSHPI%20booth_for%20form.png"
			},
			{
				src: axios.defaults.baseURL + "/resource/image/booth-submission/2021/05/MATA_for%20form.png"
			},
			{
				src: axios.defaults.baseURL + "/resource/image/booth-submission/2021/05/GVAS%20Auction%20booth_for%20form.png"
			},
			{
				src: axios.defaults.baseURL + "/resource/image/booth-submission/2021/05/DP%20Derm_for%20form.png"
			},
			{
				src: axios.defaults.baseURL + "/resource/image/booth-submission/2021/05/A2%20magazine%20booth_for%20form.png"
			}
		],
		snackbar: false,
		snackbarContent: null,
		//Basic Information
		name: null,
		description: null,
		contactName: null,
		contactEmail: "",
		noChatBooth: null,
		logo: null,
		//Content Links
		menuLink: [],
		//Documents
		haveDocument: true,
		haveVideo: true,
		documents: [],
		videos: [],
		uploadType: null,
		isUpload: false,
		documentList: [{ dataMap: {} }],
		videoList: [{ dataMap: {} }],
		currentIndex: null,
		file: null,
		deletedDocuments: [],
		//Booth Graphics
		layoutList: [],
		selectedLayoutId: null,
		totalBanner: null,
		bannerDataList: [],
		//Booth Rep
		boothRepList: [],
		showAddBoothRep: false,
		inputEmail: false,
		inputData: false,
		editData: false,
		boothRepEmail: null,
		boothRep: { dataMap: {} },
		showEditBoothRep: false,
		experienceUser: {},
		itemToDelete: null,
		dialogDelete: false,
		layoutTagFilter: [],
		layoutTagList: [],
		layoutAll: [],
		selectedLayoutImage: null,
		livePreview: false,
		showLibrary: true,
		layoutTagListFilter: [],
		boothFeatureList: [
			{
				tabTitle: "Description",
				status: true,
				icon: "mdi-information"
			},
			{
				tabTitle: "Documents",
				status: true,
				icon: "mdi-file-document"
			},
			{
				tabTitle: "Videos",
				status: true,
				icon: "mdi-play-circle-outline"
			},
			{
				tabTitle: "Links",
				status: true,
				icon: "mdi-link-variant"
			},
			{
				tabTitle: "Booth Reps",
				status: true,
				icon: "mdi-chat"
			},
			{
				tabTitle: "Products",
				status: true,
				icon: "mdi-cart-outline"
			}
		],
		//preview
		boothFeatures:[],
		showPreview: false,
		active: "Description",
		showDocument: false,
		showBannerPopup: false,
		iframeDoc: false,
		selectedDocument: {},
		iconActive: "mdi-information",
		dialog: false,
		searchParam: "",
		boothImage: null,
		productList: [],
		iframeBanner: true,
		showDialogHelp: false,
		message:"",
		isSendMessage: false,
		email: null,
		currentUrl: "",
		showAddInterests: false,
		
	}),
	mounted() {
		this.openMenu(1);
		this.listInterest();
		this.listLayoutTag();
	},
	watch: {
		steps(val) {
			if (this.e1 > val) {
				this.e1 = val;
			}
		}
	},
	methods: {
		openMenu(step) {
			this.resetLayout();
			if (step != 5) {
				this.getBooth(step);
			} else  {
				this.listBoothRep();
			} 
		},
		setStep(step) {
			if (step == 1) {
				this.name = this.entity.name;
				this.description = this.entity.description;
				this.contactName = this.entity.contactName;
				if(this.entity.contactName){
					this.contactEmail = this.entity.contactEmail;
				}
				this.noChatBooth = this.entity.dataMap.noChatBooth;
				this.logo = this.entity.logo;
			} else if (step == 2) {
				if (this.entity.boothDesignTagList == null || this.entity.boothDesignTagList.length == 0) {
					this.layoutTagFilter = [];
					this.layoutTagListFilter = this.layoutTagList;
					this.listLayout();
				} else {
					this.layoutTagFilter = this.entity.boothDesignTagList;
					this.layoutTagListFilter = this.entity.boothDesignTagList;
					this.filterLayout(true);
				}
			} else if (step == 3) {
				this.menuLink = this.entity.menuLinkList;
			} else if (step == 4) {
				this.listDocument();
				this.listVideo();
			} else if (step == 5) {
				this.listBoothRep();
			} else if (step == 6){
				this.showPreview = false;
				this.listLayout();
				this.listDocument();
				this.listVideo();
				this.listBoothRep();
				this.setDefaultActiveTab();
			}
		},
		setDefaultActiveTab() {
			let activeBoothFeature = [];
			activeBoothFeature = this.boothFeatures.filter((feature) => feature.status);
			if (activeBoothFeature.length > 0) {
				this.active = activeBoothFeature[0].tabTitle;
			}
		},
		nextStep(n) {
			if (n === this.steps) {
				this.e1 = 1;
			} else {
				this.e1 = n + 1;
			}
			this.openMenu(n + 1);
		},
		prevStep(n) {
			if (n === this.steps) {
				this.e1 = 1;
			} else {
				this.e1 = n - 1;
			}
			this.openMenu(n - 1);
		},
		getBooth(step) {
			axios.get("/system/public/booth?boothSetupId=" + this.boothSetupId).then(response => {
				this.entity = response.data;
				if(this.entity.interestList.length > 0){
					this.showAddInterests = false;
				} else {
					this.showAddInterests = true;
				}
				if (this.entity.boothFeatureLimitList == null) {
					this.entity.boothFeatureLimitList = this.boothFeatureList;
				}
				this.boothFeatures = this.boothFeatureList;
				this.boothFeatures[0].status = true;
				this.boothFeatures[3].status = true;
				this.boothFeatures[5].status = true;
				if (!this.entity.description || this.entity.description == "" || this.entity.description == null) {
					this.boothFeatures[0].status = false;
				}
				if (this.entity.menuLinkList.length < 1) {
					this.boothFeatures[3].status = false;
				}
				if (this.productList.length < 1) {
					this.boothFeatures[5].status = false;
				}

				if (step != null) {
					this.setStep(step);
				}
			});
		},
		listDocument() {
			axios.get("/system/public/document/list?boothId=" + this.entity.id).then(response => {
				this.documentList = response.data;
				this.documents = this.documentList;
				//hide empty document tab on live preview 
				this.boothFeatures[1].status = true;
				if (this.documents.length < 1) {
					this.boothFeatures[1].status = false;
				}
			});
		},
		listVideo() {
			axios.get("/system/public/video/list?boothId=" + this.entity.id).then(response => {
				this.videoList = response.data;
				this.videos = this.videoList;
				//hide empty video tab on live preview 
				this.boothFeatures[2].status = true;
				if (this.videos.length < 1) {
					this.boothFeatures[2].status = false;
				}
			});
		},
		saveStep1() {
			this.entity.name = this.name;
			this.entity.description = this.description;
			this.entity.contactName = this.contactName;
			this.entity.contactEmail = this.contactEmail;
			this.entity.dataMap.noChatBooth = this.noChatBooth;
			this.entity.logo = this.logo;
			this.update();
			this.nextStep(1);
		},
		saveStep2() {
			this.entity.layoutId = this.selectedLayoutId;
			this.entity.bannerList = this.bannerDataList;
			this.update();
		},
		saveStep3() {
			this.entity.menuLinkList = this.menuLink;
			this.update();
		},
		saveStep4() {
			let newDocumentList = [];
			newDocumentList = [...this.documents, ...this.videos];
			axios
				.post("/system/public/booth/document/edit", {
					documents: newDocumentList,
					deletedDocuments: this.deletedDocuments
				})
				.then(() => {
					this.listDocument();
					this.listVideo();
					this.nextStep(4);
				});
		},
		saveStep6() {
			this.entity.status = true;
			this.entity.transitMap.submitted = new Date().toISOString().replace(/[TZ]|\.\d{3}/g, ' ').trim();
			this.update();
			this.snackbar = true;
			this.snackbarContent = "Submitted";
		},
		update() {
			if (this.entity.menuLinkList != null) {
				let i = 1;
				this.entity.menuLinkList.forEach(menuLink => {
					menuLink.index = i;
					i++;
				});
			}
			let formData = new FormData();
			if (this.attachment2) {
				formData.append("attachment2", this.attachment2);
			}
			if (this.attachment3) {
				formData.append("attachment3", this.attachment3);
				this.entity.dataMap.bannerIndex = this.currentIndex;
			}
			if (this.attachment) {
				formData.append("attachment", this.attachment);
			}
			formData.append("entity", JSON.stringify(this.entity));
			formData.append("tenantId", this.tenantId);
			formData.append("interestUpdateFlag", this.showAddInterests);
			axios
				.post("/system/public/booth/edit", formData, {
					headers: {
						"Content-Type": "multipart/form-data"
					}
				})
				.then(() => {
					this.getBooth();
				});
		},
		addExternalLink() {
			if (!this.menuLink) {
				this.menuLink = [];
			}
			this.menuLink.push({
				status: true,
				title: null,
				url: null,
				openLinkOption: "1",
				isShowPopup: false,
				type: "External Link"
			});
		},
		deleteExternalLink(item) {
			this.menuLink = this.menuLink.filter(x => x != item);
		},
		addDocument() {
			if (!this.documents) {
				this.documents = [];
			}
			this.documents.push({
				status: true,
				type: "Document",
				value: null,
				title: null,
				boothId: this.entity.id,
				dataMap: { openLinkOption: "2", docType: true }
			});
		},
		deleteDocument(item) {
			this.documents = this.documents.filter(x => x != item);
			if (item.id && item.id != null) {
				this.deletedDocuments.push(item.id);
			}
		},
		upload(type) {
			let formData = new FormData();
			formData.append("boothId", this.entity.id);
			formData.append("experienceId", this.experienceId);
			formData.append("tenantId", this.tenantId);
			if (this.attachment1) {
				formData.append("attachment1", this.attachment1);
			}
			axios.post("/system/public/booth/setup/upload", formData).then(response => {
				let filename = response.data;
				if (type == "document") {
					this.documents[this.currentIndex].value = filename;
				} else if (type == "video") {
					this.videos[this.currentIndex].value = filename;
				} else if (type == "bannerUrl") {
					this.bannerDataList[this.currentIndex].url = filename;
				} else if (type == "bannerImage") {
					this.bannerDataList[this.currentIndex].image = filename;
				}
				this.attachment1 = null;
				this.isUpload = false;
				this.uploadType = null;
			});
		},
		addVideo() {
			if (!this.videos) {
				this.videos = [];
			}
			this.videos.push({
				status: true,
				type: "Video",
				value: null,
				title: null,
				boothId: this.entity.id,
				dataMap: { openLinkOption: "2", docType: true }
			});
		},
		deleteVideo(item) {
			this.videos = this.videos.filter(x => x != item);
			if (item.id && item.id != null) {
				this.deletedDocuments.push(item.id);
			}
		},
		openUpload(uploadType, item) {
			if (uploadType == "video") {
				this.currentIndex = this.videos.indexOf(item);
			} else if (uploadType == "document") {
				this.currentIndex = this.documents.indexOf(item);
			} else if (uploadType == "bannerUrl" || uploadType == "bannerImage") {
				this.currentIndex = this.bannerDataList.indexOf(item);
			}
			this.uploadType = uploadType;
		},
		//Booth Graphics
		listLayout() {
			axios
				.post("/system/public/layout/membership/list", {
					tenantId: this.tenantId,
					tenantPlanId: this.tenantPlanId
				})
				.then(response => {
					this.layoutList = response.data;
					this.layoutAll = this.layoutList;
					if (this.entity.layoutId != null) {
						this.selectedLayoutId = this.entity.layoutId;
						this.showLibrary = false;
						this.getLayout(1);
					}
				});
		},
		listLayoutTag() {
			axios.get("/system/public/layout/tag/list").then(response => {
				this.layoutTagList = response.data;
			});
		},
		filterLayout(isFirstCall) {
			axios.post("/system/public/layout/filter",{
				planFilter : [],
				tagFilter : this.layoutTagFilter,
				tenantPlanId: this.tenantPlanId,
				tenantId: this.tenantId
			}).then((response) => {
				this.layoutList = response.data;
				if (isFirstCall) {
					this.layoutAll = this.layoutList;
					if (this.entity.layoutId != null) {
						this.selectedLayoutId = this.entity.layoutId;
						this.showLibrary = false;
						this.getLayout(1);
					}
				}
			});
		},
		resetLayout(){
			this.layoutPlanFilter = [];
			this.layoutTagFilter = this.entity.boothDesignTagList;
			this.layoutList = this.layoutAll;
		},
		selectBoothTemplate(item) {
			this.selectedLayoutId = item.id;
			this.showLibrary = false;
			this.bannerDataList = [];
			this.getLayout(0);
		},
		getLayout(bannerDataLength) {
			axios.get("/system/public/booth/layout?id=" + this.selectedLayoutId).then(response => {
				let banner = response.data.bannerList;
				this.selectedLayoutImage = response.data.dataMap.value;
				if (bannerDataLength != 0) {
					this.bannerDataList = this.entity.bannerList;
				}
				if (this.bannerDataList.length > 0) {
					for (let i = 0; i < banner.length; i++) {
						if (banner[i].name) {
							this.bannerDataList[i].name = banner[i].name;
							this.bannerDataList[i].width = banner[i].coordinateList[2];
							this.bannerDataList[i].height = banner[i].coordinateList[3];
						}
						this.bannerDataList[i].coordinateList = banner[i].coordinateList;
						this.bannerDataList[i].skewX = banner[i].skewX;
						this.bannerDataList[i].skewY = banner[i].skewY;
					}
				} else if (this.bannerDataList.length < 1) {
					let i = 0;
					while (i < banner.length) {
						let bannerDataList = {
							sequence: i + 1,
							name: banner[i].name,
							bannerType: true,
							url: null,
							openLinkOption: "2",
							imageType: true,
							image: null,
							width: banner[i].coordinateList[2],
							height: banner[i].coordinateList[3],
							coordinateList: banner[i].coordinateList,
							skewX: banner[i].skewX,
							skewY: banner[i].skewY
						};
						this.bannerDataList.push(bannerDataList);
						i++;
					}
				}
			});
		},
		//Booth Rep
		listBoothRep() {
			axios.get("/system/public/booth/boothRep/list?&id=" + this.entity.id).then(response => {
				this.boothRepList = response.data;
				//hide empty booth rep tab on live preview 
				this.boothFeatureList[4].status = true;
				if (this.boothRepList.length < 1) {
					this.boothFeatures[4].status = false;
				}
			});
		},
		nextBoothRep() {
			axios
				.post("/system/public/booth/boothRep/find", {
					experienceId: this.experienceId,
					email: this.boothRepEmail
				})
				.then(response => {
					let boothRep = response.data;
					this.boothRep.email = this.boothRepEmail;
					if (!boothRep) {
						this.editData = true;
					} else {
						this.boothRep.id = boothRep.id;
						this.boothRep.firstName = boothRep.firstName;
						this.boothRep.lastName = boothRep.lastName;
						this.boothRep.bio = boothRep.bio;
						this.boothRep.title = boothRep.title;
						this.boothRep.password = boothRep.password;
					}
					this.inputEmail = false;
					this.inputData = true;
				});
		},
		addBoothRep() {
			this.boothRep = { dataMap: {} };
			this.boothRepEmail = null;
			this.inputEmail = true;
			this.showAddBoothRep = true;
		},
		saveBoothRep() {
			axios
				.post("/system/public/booth/boothRep/save", {
					experienceUser: this.boothRep,
					experienceId: this.experienceId,
					boothId: this.entity.id
				})
				.then(() => {
					this.listBoothRep();
					this.closeAddBoothRep();
				});
		},
		editBoothRep(item) {
			this.showEditBoothRep = true;
			this.experienceUser = {};
			this.getBoothRep(this.entity.id, item.id);
		},
		getBoothRep(boothId, experienceUserId) {
			axios.get("/system/public/booth/boothRep?boothId=" + boothId + "&experienceUserId=" + experienceUserId).then(response => {
				this.boothRep = response.data;
				this.getExperienceUser(experienceUserId);
			});
		},
		getExperienceUser(experienceUserId) {
			axios.get("/system/public/booth/boothRep/experienceUser?experienceUserId=" + experienceUserId).then(response => {
				this.experienceUser = response.data;
			});
		},
		updateBoothRep() {
			axios
				.post("/system/public/booth/boothRep/update", {
					entity: this.boothRep
				})
				.then(() => {
					this.closeAddBoothRep();
				});
		},
		closeAddBoothRep() {
			this.inputData = false;
			this.inputEmail = false;
			this.editData = false;
			this.showAddBoothRep = false;
			this.showEditBoothRep = false;
		},
		showDeleteDialog(item) {
			this.itemToDelete = item;
			this.dialogDelete = !this.dialogDelete;
		},
		deleteBoothRep() {
			var experienceUserId = this.itemToDelete.id;
			var boothId = this.entity.id;
			axios.get("/system/public/booth/boothRep/delete?experienceUserId=" + experienceUserId + "&boothId=" + boothId).then(() => {
				this.listBoothRep();
				this.dialogDelete = false;
			});
		},
		//preview
		setActive(menu) {
			this.active = menu.tabTitle;
			this.iconActive = menu.icon;
			this.dialog = false;
		},
		openDocuments(document) {
			this.selectedDocument = null;
			this.showDocument = true;
			this.iframeDoc = true;
			this.findInDocument(document.id);
		},
		findInDocument(id) {
			axios.post("/system/public/booth/document", {
				id: id,
				boothId: this.entity.id
			}).then((response) => {
				this.selectedDocument = response.data;
				if (this.selectedDocument.value && this.selectedDocument.type == "Video") {
					if (this.selectedDocument.value.includes("youtu") || this.selectedDocument.value.includes("vimeo")) {
						this.selectedDocument.value = this.getUrlEmbed(this.selectedDocument.value);
					}
					console.log("url : " + this.selectedDocument.value);
				}
			});
		},
		getUrlEmbed(url) {
			if (url.includes("youtu")) {
				let regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
				let match = url.match(regExp);
				let urlEmbed = "https://www.youtube.com/embed/" + match[2] + "?autoplay=1&showinfo=0&controls=1";
				return urlEmbed;
			} else if (url.includes("vimeo")) {
				if (!url.includes("https://player.vimeo.com/video/")) {
					let regExp = /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/;
					let match = url.match(regExp);
					let urlEmbed = "https://player.vimeo.com/video/" + match[5] + "?autoplay=1&showinfo=0&controls=1";
					return urlEmbed;
				} else {
					return url;
				}
			}
		},
		closeDoc() {
			this.showDocument = false;
			this.iframeDoc = false;
		},
		showBanner(item) {
			this.currentIndex = this.entity.bannerList.indexOf(item);
			this.showBannerPopup = true;
			this.iframeBanner = true;
			if (
				this.entity.bannerList[this.currentIndex].url &&
				(this.entity.bannerList[this.currentIndex].url.includes("youtu") || this.entity.bannerList[this.currentIndex].url.includes("vimeo"))
			) {
				this.entity.bannerList[this.currentIndex].url = this.getUrlEmbed(this.entity.bannerList[this.currentIndex].url);
			}
		},
		//Help
		sendMessage() {
			axios
				.post("/system/public/exhibitor/help/sendEmail", {
					boothId : this.entity.id,
					message: this.message,
					email: this.email,
					currentUrl: this.$router.currentRoute.path
				})
				.then(response => {
					if (response.data) {
						this.message = "";
						this.email = "";
						this.isSendMessage = true;
					}
				});
		},
		closeNotification() {
			if (this.$store.state.notification.title === "Unauthorized") {
				this.$store.commit("hideNotification");
				this.$store.commit("logout");
				this.$router.push("/" + this.tenantSlug + "/" + this.experienceSlug);
			} else if (this.$store.state.notification.title === "Forbidden") {
				this.$store.commit("hideNotification");
				this.$router.go(-1);
			} else {
				this.$store.commit("hideNotification");
			}
		},
		listInterest(){
			axios
				.post("/system/public/interest/list", {
					experienceId: this.experienceId
				})
				.then((response) => {
					this.interestList = response.data;
					})
				.catch(() => {});
		},
		/* searchProduct() {
			if (this.searchParam != "") {
				axios.get("/system/booth/product/search?boothId=" + this.entity.id + "&keyword=" + this.searchParam).then((response) => {
					this.productList = response.data;
				});
			} else {
				this.productList = this.products;
			}
		},
		clearSearch() {
			this.searchParam = "";
			this.productList = this.products;
		}, */
	}
};
</script>